<template>
    <div>
        <v-container fluid class="primary py-0 hidden-sm-and-down" v-if="1==0">
            <v-container fluid class="pb-0" :class="{'pl-12': $vuetify.breakpoint.mdAndUp}">
                <v-row align="center">
                    <v-col cols="12" sm="12" md="6">
                        <h1 class="mb-4 black--text">My Profile
                        </h1>
                    </v-col>
                </v-row>
                
            </v-container>
        </v-container>
        <v-container fluid :class="{'px-12': $vuetify.breakpoint.mdAndUp, 'pt-0': $vuetify.breakpoint.smAndDown}" class="mt-6">
            <v-row v-if="userInfo">

                <v-col cols="12" sm="12" md="7">
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-card outlined>

                                <v-list class="wrap-normal-list primary lighten-4">
                                    <v-list-item>
                                        <v-list-item-avatar size="60">
                                            <v-icon color="primary" style="font-size: 70px !important;">
                                                mdi-account-circle
                                            </v-icon>
                                        </v-list-item-avatar>

                                        <v-list-item-content>
                                            <v-list-item-title class="font-26">{{ userInfo.name}}
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                {{ userInfo.gender}}, {{moment(userInfo.dob).format('DD-MMM-YYYY')}}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action class="hidden-md-and-up">
                                            <v-list-item-action-text>
                                               <v-btn icon class="accent" color="white">
                                                   <v-icon>mdi-account-edit</v-icon>
                                               </v-btn>
                                            </v-list-item-action-text>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list>
                                <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }">
                                <v-form @submit.prevent="updateProfile">
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="12">
                                            <h2 class="font-weight-regular">Personal Details</h2>
                                        </v-col>                                        
                                    </v-row>
                                    <v-row dense>
                                        <v-col cols="12" sm="12" md="6">
                                            <ValidationProvider name="First Name" rules="required" v-slot="{ errors }">
                                                <v-text-field 
                                                    dense 
                                                    v-model="patient.first_name" 
                                                    color="darkPrimary" 
                                                    label="First Name*" 
                                                    outlined 
                                                    autofocus
                                                    :error-messages="errors"
                                                ></v-text-field>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6">
                                            <ValidationProvider name="Last Name" rules="required" v-slot="{ errors }">
                                                <v-text-field 
                                                    dense 
                                                    v-model="patient.last_name" 
                                                    color="darkPrimary" 
                                                    label="Last Name*" 
                                                    outlined 
                                                    autofocus
                                                    :error-messages="errors"
                                                >
                                                </v-text-field>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6">
                                                <v-text-field dense v-model="patient.height" type="number" color="darkPrimary" label="Height(cm)" outlined autofocus></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6">
                                                <v-text-field dense v-model="patient.weight" type="number" color="darkPrimary" label="Weight(kg)" outlined autofocus></v-text-field>
                                        </v-col>
                                        <v-col
                                            class="d-flex"
                                            cols="12"
                                            sm="6"
                                        >
                                            <v-select
                                            v-model="patient.blood_group"
                                            :items="bloodGroups"
                                            label="Blood Group"
                                            dense
                                            color="darkPrimary"
                                            outlined
                                            ></v-select>
                                        </v-col>    

                                        <v-col
                                            class="d-flex"
                                            cols="12"
                                            sm="6"
                                        >
                                            <v-autocomplete
                                            :items="timezoneList"
                                            v-model="patient.timezone"
                                            label="Timezone"
                                            outlined
                                            dense                  
                                            color="darkPrimary"     
                                            name="timezone"                                              
                                            item-color="darkPrimary"
                                            item-text="name"
                                            item-value="id"
                                            :allow-overflow="false"                                                                   
                                            
                                    ></v-autocomplete>
                                        </v-col>      
                                                  
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <city-autocomplete
                                                ref="city_autocomplete"
                                                v-on:placechanged="getCity"                                    
                                                :dense="true"
                                                :place_types="'(cities)'"
                                                :place_filter="[]"
                                            ></city-autocomplete>
                                        </v-col>       
                                         <v-col                                            
                                            cols="12"
                                            
                                            sm="6"
                                        >
                                            <v-text-field 
                                                :value="patient.code+''+patient.mobile"
                                                label="Mobile*" 
                                                dense
                                                name="mobile" 
                                                outlined                
                                                readonly
                                                @click="showEditMobileDialogFunc"
                                                :append-icon="'mdi-pencil'"   
                                                @click:append="showEditMobileDialogFunc"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col                                                    
                                        cols="12"
                                        sm="6"
                                    >
                                        <v-text-field 
                                            v-model="patient.email"
                                            label="Email"                                                    
                                            dense
                                            name="email" 
                                            outlined
                                            placeholder="Email"
                                            @click="showEditEmailDialogFunc"
                                            :append-icon="'mdi-pencil'"   
                                            @click:append="showEditEmailDialogFunc"
                                        ></v-text-field>
                                        </v-col>  
                                        <v-col                                                    
                                            cols="12"
                                            sm="6"
                                        >
                                        <ValidationProvider name="Password" rules="min:8" v-slot="{ errors }">
                                            <v-text-field 
                                                v-model="patient.password"
                                                label="Password"                                                    
                                                dense                                                    
                                                name="password" 
                                                color="darkPrimary"
                                                outlined
                                                type="password"
                                                placeholder="Password"
                                                :error-messages="errors"
                                            ></v-text-field>
                                            </ValidationProvider>
                                        </v-col>   
                                    </v-row>
                                  
                                    <v-row>
                                        <v-col cols="12" sm="12" md="12" class="text-right">
                                            <v-btn 
                                            :loading="loading"
                                            rounded 
                                            :disabled="loading || invalid"                                            
                                            class="accent"
                                            type="submit"
                                            >
                                                Update Profile 
                                            </v-btn>
                                        </v-col>
                                        </v-row>
                                        
                                </v-card-text>                                
                                </v-form>
                                </ValidationObserver>


                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>               

            </v-row>

<v-dialog
                v-model="emailOtpObj.showDialog"
                scrollable
                :overlay="false"
                max-width="500px"
                transition="dialog-transition"            
            >
            <v-card class="">
                <v-card-title class="">Update Email</v-card-title>
                <v-card-text>
                    <ValidationObserver v-if="!emailOtpObj.otpSent" v-slot="{ invalid, handleSubmit }">
                        <v-form class="pt-1"  @submit.prevent="handleSubmit(sendEmailOtp)">
                            <div class="d-flex flex-row flex-nowrap">                                                                                                         
                            
                                <ValidationProvider class="flex-grow-1" name="Email" rules="required" v-slot="{ errors }">
                                    <v-text-field
                                        outlined                                        
                                        label="Email"                                                                                            
                                        class="ml-2"                                                                                            
                                        color="darkPrimary"
                                        dense
                                        autofocus                                                    
                                        name="Email"
                                        v-model.number="emailOtpObj.updatedEmail"
                                        :error-messages="errors"
                                    ></v-text-field>
                                </ValidationProvider>
                            </div>
                            <v-btn rounded :disabled="emailOtpObj.otpSubmitLoader" color="accent" class="white--text no-uppercase" type="submit">
                                Send Code
                            </v-btn>
                        </v-form>
                    </ValidationObserver>
                    <ValidationObserver v-else ref="verifyEmailOtp" v-slot="{ invalid, handleSubmit }">
                            <v-form v-show="emailOtpObj.otpSent" @submit.prevent="handleSubmit(verifyEmailOTP)">
                                <v-row>
                                    <v-col cols="12" sm="12" md="8" class="mb-0 pb-0">
                                        <ValidationProvider name="Code" rules="required" v-slot="{ errors }">
                                            <v-text-field
                                                outlined
                                                label="Verification code"
                                                type="number"
                                                dense
                                                autofocus
                                                v-model="emailOtpObj.otp"
                                                :error-messages="errors"
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4" mb-0 pb-0>
                                        <v-btn rounded :disabled="emailOtpObj.otpSubmitLoader" color="accent" class="white--text no-uppercase"  type="submit">
                                            Verify
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="12" md="9" class="mt-0 pt-0">                                                                                                                       
                                        <v-row style="font-size: 13px" class="mt-0 pt-0">
                                            <v-col sm="6" class="text-left">
                                                <a class="darkPrimary--text" href="#" @click="emailOtpObj.otpSent = false">Change Email?</a>
                                                <br>
                                                <span class="darkPrimary--text">{{emailOtpObj.updatedEmail}}</span>
                                            </v-col>
                                            <v-col sm="6" class="text-right">
                                                <a href="#" class="darkPrimary--text" @click="sendEmailOtp()">Resend Code</a>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </ValidationObserver>
                </v-card-text>
                
            </v-card>
        </v-dialog>

            <v-dialog
                v-model="mobileObj.showEditMobileDialog"
                scrollable
                :overlay="false"
                max-width="500px"
                transition="dialog-transition"            
            >
            <v-card class="">
                <v-card-title class="">Update Mobile</v-card-title>
                <v-card-text>
                    <ValidationObserver v-if="!mobileObj.otpSent" v-slot="{ invalid, handleSubmit }">
                        <v-form class="pt-1"  @submit.prevent="handleSubmit(sendOtp)">
                            <div class="d-flex flex-row flex-nowrap">
                                
                                    <v-autocomplete
                                        :items="codes"
                                        v-model="mobileObj.updatedCode"                                                                                                                                                
                                        color="darkPrimary"
                                        outlined                                                    
                                        dense                   
                                        style="max-width:80px; !important"                                                                        
                                        label="Code"
                                        item-text="dialCode"
                                        item-value="dialCode"                                                    
                                        autofocus
                                    >                                               
                                    </v-autocomplete>                                            
                            
                                <ValidationProvider class="flex-grow-1" name="Mobile" rules="required|length:10" v-slot="{ errors }">
                                    <v-text-field
                                        outlined
                                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                        label="Mobile Number"                                                    
                                        type="number"
                                        class="ml-2"                                                    
                                        maxlength="10"
                                        color="darkPrimary"
                                        dense
                                        autofocus                                                    
                                        name="Mobile"
                                        v-model.number="mobileObj.updatedNumber"
                                        :error-messages="errors"
                                    ></v-text-field>
                                </ValidationProvider>
                            </div>
                            <v-btn rounded :disabled="mobileObj.otpSubmitLoader" color="accent" class="white--text no-uppercase" type="submit">
                                Send OTP
                            </v-btn>
                        </v-form>
                    </ValidationObserver>
                    <ValidationObserver v-else ref="verifyOtp" v-slot="{ invalid, handleSubmit }">
                            <v-form v-show="mobileObj.otpSent" @submit.prevent="handleSubmit(verifyOTP)">
                                <v-row>
                                    <v-col cols="12" sm="12" md="8" class="mb-0 pb-0">
                                        <ValidationProvider name="OTP" rules="required" v-slot="{ errors }">
                                            <v-text-field
                                                outlined
                                                label="OTP"
                                                type="number"
                                                dense
                                                autofocus
                                                v-model="mobileObj.otp"
                                                :error-messages="errors"
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4" mb-0 pb-0>
                                        <v-btn rounded :disabled="mobileObj.otpSubmitLoader" color="accent" class="white--text no-uppercase"  type="submit">
                                            Verify OTP
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="12" md="9" class="mt-0 pt-0">                                                                                                                       
                                        <v-row style="font-size: 13px" class="mt-0 pt-0">
                                            <v-col sm="6" class="text-left">
                                                <a class="darkPrimary--text" href="#" @click="mobileObj.otpSent = false">Change Number?</a>
                                                <br>
                                                <span class="darkPrimary--text">{{mobileObj.updatedNumber}}</span>
                                            </v-col>
                                            <v-col sm="6" class="text-right">
                                                <a href="#" class="darkPrimary--text" @click="sendOtp()">Resend OTP</a>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </ValidationObserver>
                </v-card-text>
                
            </v-card>
        </v-dialog>

        </v-container>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import CityAutocomplete from '../components/CityAutocomplete.vue';
    import * as countryCodeUtil from '../data.js'

    export default {
        name: "Home",
        components: {            
            CityAutocomplete
        },
        computed: {
            ...mapGetters([
                'accessToken',
                'userInfo'
            ]),
        },
        mounted() {
            this.getPatientDetails()
            this.timezoneList = this.moment.tz.names()                         
            this.codes = countryCodeUtil.countryCodes
        },
        methods: {            
            getCity(place) {                
                this.patient.city = place.name
            },
            updateProfile(){
                this.loading = true;
                this.axios.post(`${process.env.VUE_APP_API_URL}/api/patients/update-details`, this.patient).then((response) => {
                    if (response.data.status === 1) {                        
                        var newTimezone = response.data.data.timezone
                        this.$store.dispatch('storeTimezone', newTimezone)  
                        this.$store.dispatch('storeUserInfo', response.data.data)
                        this.$router.replace({name: 'myProfile'})
                    }                    
                }).catch((error) => {                    
                    console.log(error)
                }).finally(()=>{
                    this.loading = false;
                });
            },
            getPatientDetails(){
                
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/patients/` + this.userInfo.id, {
                    params: this.patient
                }).then((response) => {
                    if (response.data.status === 1) {
                        this.patient = response.data.data
                        if(this.patient.city)
                                this.$refs.city_autocomplete.updateCity(this.patient.city)
                    }                    
                }).catch((error) => {                    
                    console.log(error)
                }).finally(()=>{
                    this.loading = false;
                });
            },
            showEditMobileDialogFunc(){
                console.log("CALLED")
                this.mobileObj.updatedCode = this.patient.code
                this.mobileObj.updatedNumber = this.patient.mobile
                this.mobileObj.otpSent=false
                this.mobileObj.otp=""
                this.mobileObj.showEditMobileDialog = true
            },
            sendOtp() {
                let sendOTPRequest = {
                    mobile: this.mobileObj.updatedNumber,
                    code: this.mobileObj.updatedCode
                }
                this.mobileObj.otpSubmitLoader = true
                this.axios.post(`${process.env.VUE_APP_API_URL}/api/authentication/send-otp`, sendOTPRequest)
                    .then(() => {
                        this.mobileObj.otpSent = true;
                    }).catch((error)=>{
                    console.log(error);
                }).finally(() => {
                    this.mobileObj.otpSubmitLoader = false
                })
            },
            verifyOTP() {
                let verifyOTPRequest = {                    
                    otp: this.mobileObj.otp,
                    mobile: this.mobileObj.updatedNumber,                    
                    code:this.mobileObj.updatedCode
                }
                this.mobileObj.otpSubmitLoader = true
                this.axios.post(`${process.env.VUE_APP_API_URL}/api/patients/update-mobile`, verifyOTPRequest)
                    .then((response) => {
                        if(response.data.status === 1) {
                            this.getPatientDetails()                                                       
                            this.$store.commit('showSnackbar', {message: response.data.message})
                            this.mobileObj.showEditMobileDialog = false
                        } else {
                            this.$store.commit('showSnackbar', {message: response.data.message})                            
                        }
                    }).catch((error)=>{
                    console.log(error);
                }).finally(() => {
                    this.mobileObj.otpSubmitLoader = false
                })
            },
            showEditEmailDialogFunc(){                                
                this.emailOtpObj.updatedEmail = this.patient.email
                this.emailOtpObj.otpSent = false
                this.emailOtpObj.otp = ""
                this.emailOtpObj.showDialog = true
            },
            sendEmailOtp() {
                let sendOTPRequest = {
                    email: this.emailOtpObj.updatedEmail,                    
                }
                this.otpSubmitLoader = true
                return new Promise((resolve) => {
                    this.axios.post(`${process.env.VUE_APP_API_URL}/api/authentication/v2/send-verification-mail`, sendOTPRequest)
                    .then((response) => {
                        if(response.data.status == 1){                                         
                            this.$store.commit('showSnackbar', {message: response.data.message, color: ''})
                            this.emailOtpObj.otpSent = true;
                            this.emailOtpObj.sendOtpApiSuccess = true
                        }                        
                        
                    }).catch((error)=>{
                        console.log(error);
                    }).finally(() => {
                        this.emailOtpObj.otpSubmitLoader = false
                        resolve()
                    })
                })
                
            },
            verifyEmailOTP() {
                let verifyOTPRequest = {                    
                    otp: this.emailOtpObj.otp,
                    email: this.emailOtpObj.updatedEmail
                }
                this.emailOtpObj.otpSubmitLoader = true
                this.axios.post(`${process.env.VUE_APP_API_URL}/api/patients/update-email`, verifyOTPRequest)
                    .then((response) => {
                        if(response.data.status === 1) {
                            this.getPatientDetails()                                                       
                            this.$store.commit('showSnackbar', {message: response.data.message, color: ''})
                            this.emailOtpObj.showDialog = false
                        } else {
                            this.$store.commit('showSnackbar', {message: response.data.message, color: ''})                                   
                        }
                    }).catch((error)=>{
                    console.log(error);
                }).finally(() => {
                    this.emailOtpObj.otpSubmitLoader = false
                })
            },
        },
        data: () => ({
            bloodGroups: ["O-","O+","A-","A+","B-","B+","AB-","AB+"],
            patient:{
                height:null,
                weight:null,
                blood_group:null,
                user:{}
            },
            loading:false,
            timezoneList:[],
            mobileObj:{
                updatedCode:"",
                updatedNumber :"",
                otpSent:false,
                otp:"",
                showEditMobileDialog:false,
                otpSubmitLoader:false
            },
            codes:[],
            emailOtpObj:{
                    updatedEmail:"",                    
                    otpSent:false,
                    otp:"",
                    showDialog:false,
                    otpSubmitLoader:false,
                    sendOtpApiSuccess:false
                },
        }),
    }
</script>

<style>
    .v-application .primary.lighten-4.option-cards {
        border-left: 10px solid #5c6bc0 !important;
    }

    .solo-bordered .v-input__slot {
        border: 1px solid #ccc;
    }
</style>